import { styled } from '@mui/material';
import FurtherDatePicker from 'further-ui/components/DatePicker';

const DatePicker = styled(FurtherDatePicker)(({ theme }) => ({
  '& .Mui-disabled': {
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,

    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: theme.shape.borderRadius,
      borderColor: theme.palette.grey[100],
    },
  },
}));

export default DatePicker;
